import { render } from "./ClientDocument.vue?vue&type=template&id=25e0f3af"
import script from "./ClientDocument.vue?vue&type=script&lang=js"
export * from "./ClientDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__